/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AssignmentPercentageDecimalsSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('ASSIGNMENT_PERCENTAGE_DECIMALS')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class AssignmentPercentageDecimalsSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssignmentPercentageDecimalsSettingParser.decode(input).map(res => new AssignmentPercentageDecimalsSetting(res));
    }
    static unsafeDecode(input) {
        return AssignmentPercentageDecimalsSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentPercentageDecimalsSettingParser.encode(data);
    }
    static schema() {
        return AssignmentPercentageDecimalsSettingParser.schema();
    }
}
